export const userConstants = {
  REQUEST_START: 'REQUEST_START',
  REQUEST_STOP: 'REQUEST_STOP',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_LOGIN_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_LOGIN_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_LOGIN_FAILURE',

  VALIDATE_FORGOT_PASSWORD_TOKEN_REQUEST: 'VALIDATE_FORGOT_PASSWORD_TOKEN_REQUEST',
  VALIDATE_FORGOT_PASSWORD_TOKEN_SUCCESS: 'VALIDATE_FORGOT_PASSWORD_TOKEN_SUCCESS',
  VALIDATE_FORGOT_PASSWORD_TOKEN_FAILURE: 'VALIDATE_FORGOT_PASSWORD_TOKEN_FAILURE',

  COMPLETE_FORGOT_PASSWORD_REQUEST: 'COMPLETE_FORGOT_PASSWORD_REQUEST',
  COMPLETE_FORGOT_PASSWORD_SUCCESS: 'COMPLETE_FORGOT_PASSWORD_SUCCESS',
  COMPLETE_FORGOT_PASSWORD_FAILURE: 'COMPLETE_FORGOT_PASSWORD_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  CHECK_REGISTRATION_TOKEN: 'CHECK_REGISTRATION_TOKEN',
  CHECK_REGISTRATION_TOKEN_SUCCESS: 'CHECK_REGISTRATION_TOKEN_SUCCESS',
  CHECK_REGISTRATION_TOKEN_ERROR: 'CHECK_REGISTRATION_TOKEN',

  CHECK_TWO_STEP_VERIFICATION_TOKEN: 'CHECK_TWO_STEP_VERIFICATION_TOKEN',
  CHECK_TWO_STEP_VERIFICATION_TOKEN_SUCCESS: 'CHECK_TWO_STEP_VERIFICATION_TOKEN_SUCCESS',
  CHECK_TWO_STEP_VERIFICATION_TOKEN_ERROR: 'CHECK_TWO_STEP_VERIFICATION_TOKEN',

  TWO_STEP_VERIFICATION_REQUEST: 'TWO_STEP_VERIFICATION_REQUEST',
  TWO_STEP_VERIFICATION_SUCCESS: 'TWO_STEP_VERIFICATION_SUCCESS',
  TWO_STEP_VERIFICATION_ERROR: 'TWO_STEP_VERIFICATION_ERROR',

  REGISTRATION_REQUEST: 'REGISTRATION_REQUEST',
  REGISTRATION_SUCCESS: 'REGISTRATION_SUCCESS',
  REGISTRATION_ERROR: 'REGISTRATION_ERROR',

  GET_DOCUMENTS_FOR_USER_LOADING: 'GET_DOCUMENTS_FOR_USER_LOADING',
  GET_DOCUMENTS_FOR_USER_SUCCESS: 'GET_DOCUMENTS_FOR_USER_SUCCESS',
  GET_DOCUMENTS_FOR_USER_ERROR: 'GET_DOCUMENTS_FOR_USER_ERROR',

  SAVING_DOCUMENT_FOR_USER_LOADING: 'SAVING_DOCUMENT_FOR_USER_LOADING',
  SAVING_DOCUMENT_FOR_USER_SUCCESS: 'SAVING_DOCUMENT_FOR_USER_SUCCESS',
  SAVING_DOCUMENT_FOR_USER_ERROR: 'SAVING_DOCUMENT_FOR_USER_ERROR',
} as const
